import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import trophy from "../../assests/trophy.png";
import winner1 from "../../assests/winner1.png";
import winner2 from "../../assests/winner2.png";
import winner3 from "../../assests/winner3.png";
import logo from "../../assests/BEFLogo.png";
import { getContestLeaderboard } from "../../redux/services/contestSlice";
import Loader from "../../common/Loader";

const Leaderboard = () => {
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search);
  const contestId = queryParam.get("contestId");
  const dispatch = useDispatch();
  const getContestLeaderboardData = useSelector((state) => state?.contest?.contestLeaderboardData);
  const LeaderboardLoading = useSelector((state) => state?.contest?.LeaderboardLoading);
  const RanksData = getContestLeaderboardData?.[0]?.ranks;
  console.log("getContestLeaderboardData", RanksData);

  const getBackgroundStyle = (rank) => {
    if (rank === 1) {
      return { backgroundImage: `url(${winner1})` };
    } else if (rank === 2) {
      return { backgroundImage: `url(${winner2})` };
    } else if (rank === 3) {
      return { backgroundImage: `url(${winner3})` };
    }
  };

  const getAllContestApi = useCallback(async () => {
    try {
      await dispatch(getContestLeaderboard({ ContestId: contestId }));
    } catch (error) {}
  }, [dispatch, contestId]);

  useEffect(() => {
    getAllContestApi();
  }, [getAllContestApi]);
  return (
    <>
      {LeaderboardLoading ? (
        <Loader />
      ) : (
        <div className="bg-card">
          {RanksData && RanksData?.length > 0 ? (
            <>
              <div className={`relative bg-cover bg-center w-full flex flex-col items-center p-5 rounded-xl`}>
                {/* Top message */}
                <div className="mt-10 grid max-sm:grid-cols-1 grid-cols-3 justify-center items-end gap-5 w-full">
                  {RanksData?.map((list) =>
                    list.winners
                      ?.filter((item) => item.rank <= 3)
                      ?.map((item, i) => (
                        <div key={i} className={`flex flex-col items-center max-sm:w-full ${item.rank === 1 ? "sm:order-1" : item.rank === 3 ? "sm:order-2" : ""}`}>
                          <div className={`${item.rank === 1 ? "w-64 h-48" : item.rank === 2 ? "w-52 h-40" : item.rank === 3 ? "w-48 h-32" : ""}`}>
                            <img src={trophy} alt="Trophy" className="w-full h-full" />
                          </div>
                          <div className={`w-full rounded-t-lg text-white font-semibold py-3 text-center bg-cover ${item.rank === 1 ? "text-6xl" : item.rank === 2 ? "text-4xl" : item.rank === 3 ? "text-2xl" : ""}`} style={getBackgroundStyle(item.rank)}>
                            {item.rank}
                          </div>
                          <div className="w-full bg-card text-center rounded-b-xl shadow p-4">
                            <img src={item.profileImage || logo} alt={item.firstName} className="w-12 h-12 rounded-full mx-auto mb-2" />
                            <p className="font-semibold text-sm capitalize">
                              {item.firstName} {item.lastName}
                            </p>
                            {list.price !== 0 && <p className="text-sm text-foreground font-semibold">₹{list.price}</p>}
                            <p className="text-xs text-muted-foreground">{item.points}</p>
                          </div>
                        </div>
                      )),
                  )}
                </div>
              </div>
              {RanksData?.some((list) => list?.winners?.some((item) => item.rank > 3)) && (
                <div className="pt-7">
                  <div className="bg-input-box rounded-xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 p-5 w-full max-h-[450px] overflow-y-auto overflow-x-hidden [&::-webkit-scrollbar]:w-0">
                    {RanksData?.map((list) =>
                      list.winners
                        ?.filter((item) => item.rank > 3)
                        ?.map((user, index) => (
                          <div key={index} className="w-full mx-auto flex items-center gap-x-4 rounded-xl bg-card p-3 sm:p-6 shadow-theme ">
                            <img className="size-12 rounded-full" src={user.profileImage || logo} alt="ChitChat Logo" />
                            <div>
                              <div className="max-sm:text-sm text-muted-foreground">{user.rank} TH RANK</div>
                              <p className="text-md sm:text-xl font-medium capitalize">
                                {user.firstName} {user.lastName}
                              </p>
                            </div>
                          </div>
                        )),
                    )}
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="flex items-center justify-center p-4 w-ful">
              <div className="text-center animate__animated animate__fadeIn animate__delay-1s">
                <h2 className="font-heading text-xl sm:text-2xl font-bold text-primary mb-2 sm:mb-4">No Data Found</h2>
                <p className="text-md text-muted-foreground mb-6">Unfortunately, we couldn't find any results matching your search.</p>
                <div className="mt-6">
                  <button className="px-6 py-3 bg-primary text-white text-lg font-semibold rounded-xl shadow-theme hover:bg-accent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-300 ease-in-out transform hover:scale-105" onClick={() => window.location.reload()}>
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Leaderboard;
